export default __webpack_public_path__ + "static/mk-a51cf2ae49f4253b981d8470b938f536.svg";